<div class="message-administration">

  <sc-master-detail [selection]="[selected]" [data]="messages" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <sc-scroll-pane>
      <div class="form">
        <div class="message-details">


          <div class="form-box grid" [formGroup]="detailsFormGroup" *ngIf="workingCopyDetails">
            <sc-padding>
              <sc-flex [vertical]="true" [stretchContent]="true">

                <mat-form-field style="grid-column: 1; grid-row: 1;">
                  <input formControlName="name" name="name" matInput
                    placeholder="{{'name' | translate: ['tmc-yard.entity.transport-message.name', translationService.language]}}"
                    [required]="true" />
                </mat-form-field>

                <sc-dictionary-field style="grid-column: 1; grid-row: 2;" [model]="workingCopyDetails.messageLong"
                  [defaultLabel]="'message long'"
                  [labelDictionaryKey]="'tmc-yard.entity.transport-message.message-long'" [required]="true"
                  [maxlength]="4000" (dictionaryChanged)="onDictionaryChanged()">
                </sc-dictionary-field>
                <sc-dictionary-field style="grid-column: 1; grid-row: 3;" [model]="workingCopyDetails.messageShort"
                  [defaultLabel]="'message short'"
                  [labelDictionaryKey]="'tmc-yard.entity.transport-message.message-short'" [required]="true"
                  [maxlength]="4000" (dictionaryChanged)="onDictionaryChanged()">
                </sc-dictionary-field>

              </sc-flex>
            </sc-padding>
          </div>

        </div>
      </div>
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>
      <button mat-stroked-button type="button" class="config-changed-button" (click)="sendMessage()"
        [disabled]="isLoading" *ngIf="sendEnabled">
        {{'send' | translate: ['tmc-yard.widgets.message-administration.message-details.action.send-message',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button type="button" class="config-changed-button" (click)="cancel()"
        [disabled]="!cancelEnabled">{{'cancel'
        | translate: ['tmc-yard.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button type="button" class="config-changed-button" (click)="save()"
        [disabled]="!saveEnabled">{{'save' |
        translate:
        ['tmc-yard.action.save',
        translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>
</div>